import { SplashScreen } from '@jobcost-monorepo/ui';
import {
  API,
  BASE,
  checkTokenValidity,
  I18N,
  ME,
  removeTokenCookies,
  ROUTES,
  URL_USERS,
  V1,
} from '@jobcost-monorepo/utils';
import Cookies from 'js-cookie';
import { createContext, useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { apiClient, IUser } from '@jobcost-monorepo/crud';

export interface AuthContextProp {
  isAuthenticated: boolean;
  loading: boolean;
  user: IUser | null;
}

export const AuthContext = createContext<AuthContextProp>({
  isAuthenticated: false,
  loading: false,
  user: null,
});

export const useAuth = (): AuthContextProp => useContext(AuthContext);

export const AuthProvider = () => {
  const [user, setUser] = useState<IUser | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const lang = 'it';

  const loadUser = async () => {
    setLoading(true);
    const token = await checkTokenValidity();
    if (token) {
      const { data } = await apiClient.get<IUser>({
        url: `${BASE}${API}${V1}${URL_USERS}${ME}`,
      });

      if (data?.email) {
        setUser(data);
        if (data.hasDarkTheme) {
          document.documentElement.classList.add('dark');
        }
        lang && Cookies.set(I18N, lang.split('-')[0]);
        return setLoading(false);
      }
    }
    navigate(`/${ROUTES.SIGN_IN}`);
    removeTokenCookies();
    return setLoading(false);
  };

  useEffect(() => {
    void loadUser();
  }, []);

  if (!user || loading) return <SplashScreen />;

  return (
    <AuthContext.Provider value={{ isAuthenticated: !!user, user, loading }}>
      <Outlet />
    </AuthContext.Provider>
  );
};
